module.exports = __webpack_public_path__ + "img/honghe.9576936c.png";